import React, { ReactNode } from "react";
import ContainerComponent from "../../../../components/Container/ContainerComponent";
import ButtonComponent from "../../../../components/Button/ButtonComponent";
import TypographyComponent from "../../../../components/Typography/ThypographyComponent";
import BoxComponent from "../../../../components/Box/BoxComponent";
import SvgComponent from "../../../../components/Image/SvgComponent";

interface CategoriasProps {
    categoriaSelecionada: string;
    categorias: Categoria[];
    onClickCategoriaSelecionada: (value: string) => void;
}

interface Categoria {
    label: string;
    value: string;
    icon: ReactNode;
}

const CategoriasComponent = (props: CategoriasProps) => {
    return <ContainerComponent
        component="section"
        sx={{
            display: 'flex',
            flexDirection: 'column',
            mt: 3
        }}
    >
        <TypographyComponent variant="h2" mb={1}
            sx={{
                fontFamily: '"Font 2", "Roboto", "Helvetica", "Arial", sans-serif',
                fontWeight: 700,
                fontStyle: 'normal',
                fontSize: '1.25rem',
                lineHeight: 32 / 20,
                letterSpacing: '0em',
                display: 'flex',
                alignItems: 'center'
            }}>
            Categorias
        </TypographyComponent>

        <BoxComponent
            sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}
            component="div"
        >
            {Array.isArray(props.categorias) && props.categorias.map((item: Categoria, index: number) => {
                return <ButtonComponent
                    id={`categoria_${item.value.toLowerCase()}`}
                    key={`categoria_${item.value.toLowerCase()}`}
                    type="button"
                    sx={{
                        height: "44px",
                        backgroundColor: props.categoriaSelecionada === item.value ? "#EF4444" : "#F3F4F6",
                        color: props.categoriaSelecionada === item.value ? "#FFFFFF !important" : "#1F2937 !important",
                        borderRadius: 30,
                        pt: "8px",
                        pr: "16px",
                        pb: "8px",
                        pl: "16px",
                        gap: 1,
                        textTransform: "inherit",
                        // fontFamily: '"Font 3", "Roboto", "Helvetica", "Arial", sans-serif',
                        // fontWeight: 400,        // Regular
                        // fontSize: '1.25rem',   // 20px / 16px
                        // lineHeight: 1.4,       // 28px / 20px
                        // letterSpacing: '0em',
                        // textAlign: 'center',
                        // display: 'flex',
                        // alignItems: 'center',
                        // justifyContent: 'center',
                    }}
                    onClick={() => props.onClickCategoriaSelecionada(item.value)}
                >
                    <SvgComponent
                        icon={item.icon}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            "& svg, & svg *": {
                                fill: props.categoriaSelecionada === item.value ? "#FFFFFF !important" : "#1F2937 !important",
                                stroke: props.categoriaSelecionada === item.value ? "#FFFFFF !important" : "#1F2937 !important",
                            },
                        }}
                    />
                    
                    {item.label}
                </ButtonComponent>
            })}
        </BoxComponent>
    </ContainerComponent>
}

export default CategoriasComponent;